import { UseMutationResult, useMutation, useQueryClient } from "react-query";

import { useAxios } from "lib/hooks/useAxios";
import { IAvatarItem } from "lib/types";

export interface IUseExchangeTicketForRandomItemArgs {
  onSuccess?: (data: ExchangeTicketForRandomItemResponse) => void;
}

export type ExchangeTicketForRandomItemResponse = {
  avatar_item?: IAvatarItem;
};

export default function useExchangeTicketForRandomItem({
  onSuccess,
}: IUseExchangeTicketForRandomItemArgs): UseMutationResult<
  ExchangeTicketForRandomItemResponse,
  unknown,
  void
> {
  const axios = useAxios();
  const queryClient = useQueryClient();

  const exchange = async (): Promise<ExchangeTicketForRandomItemResponse> => {
    const response = await axios({
      method: "post",
      url: `/v1/season/tickets/exchange-random`,
    }).then((r) => r.data as ExchangeTicketForRandomItemResponse);

    queryClient.invalidateQueries("seasonMap", { exact: true });
    queryClient.invalidateQueries("avatar", { exact: true });
    queryClient.invalidateQueries("seasonTicketCount", { exact: true });

    return response;
  };

  const mutation = useMutation(exchange, { onSuccess });

  return mutation;
}
